/**
 * More specific routes must come before less specific ones
 * to prevent prefix-matching bugs (e.g. /championship2026-form-application
 * must be listed before  /championship2026)
 */
const mobileRoutes = new Set([
    '/store',
    '/checkout',
    '/leaderboards',
    '/profile',
    '/replay',
    '/about',
    '/values-examples',
    '/values',
    '/catan-rules',
    '/community',
    '/faq',
    '/privacy-policy',
    '/careers',
    '/terms',
    '/refund-policy',
    '/press-kit',
    '/championship2025',
    '/championship2026-form-application',
    '/championship2026-form-announcement',
    '/championship2026-form-result',
    '/championship2026',
])

export function matchMobileRoute(pathname: string): string | undefined {
    for(const route of mobileRoutes) if(pathname.includes(route)) return route
    return undefined
}
